(() => {
  if (!customElements.get('dn-collage-list')) {
    class DnCollageList extends HTMLElement {
      constructor() {
        super();

        this.isAccordion = this.hasAttribute('data-dn-accordion');
        this.headers = Array.from(this.querySelectorAll('.dn-collage-tabs-header'));

        this.onClick = this.onClick.bind(this);
        this.onMouseOver = this.onMouseOver.bind(this);
        this.onDocClick = this.onDocClick.bind(this);
        this.onResize = this.onResize.bind(this);

        this.addEventListener('click', this.onClick);

        if (!this.isAccordion) {
          this.addEventListener('mouseover', this.onMouseOver);
        }

        if (this.isAccordion) {
          this.initAccordionPanels();
          window.addEventListener('resize', this.onResize);
        }

        document.addEventListener('click', this.onDocClick);
      }

      disconnectedCallback() {
        this.removeEventListener('click', this.onClick);
        this.removeEventListener('mouseover', this.onMouseOver);
        document.removeEventListener('click', this.onDocClick);
        window.removeEventListener('resize', this.onResize);
      }

      onClick(e) {
        const dot = e.target.closest('[data-lookbook-dot]');
        if (dot && this.contains(dot)) {
          e.preventDefault();
          e.stopPropagation();
          this.toggleHotspot(dot);
          return;
        }

        const header = e.target.closest('.dn-collage-tabs-header');
        if (!header || !this.contains(header)) return;

        const blockId = header.dataset.blockId;
        if (!blockId) return;

        this.closeAllHotspots();

        if (this.isAccordion) {
          const isOpen = header.classList.contains('is-active');
          this.pauseAllMedia();

          if (isOpen) {
            this.setActive(null);
            return;
          }

          this.setActive(blockId);
          return;
        }

        if (header.classList.contains('is-active')) return;

        this.pauseAllMedia();
        this.setActive(blockId);
      }

      onMouseOver(e) {
        if (this.isAccordion) return;

        const header = e.target.closest('.dn-collage-tabs-header');
        if (!header || !this.contains(header)) return;

        const blockId = header.dataset.blockId;
        if (!blockId) return;

        if (header.classList.contains('is-active')) return;

        this.pauseAllMedia();
        this.closeAllHotspots();
        this.setActive(blockId);
      }

      onDocClick(e) {
        if (!this.contains(e.target)) this.closeAllHotspots();
      }

      onResize() {
        if (!this.isAccordion) return;
        this.refreshOpenPanels();
      }

    setActive(blockId) {
  const headers = Array.from(this.querySelectorAll('.dn-collage-tabs-header'));
  const descriptions = Array.from(this.querySelectorAll('.dn-collage-description'));
  const cards = Array.from(this.querySelectorAll('.collage-list__card'));

  const currentCard = this.querySelector('.collage-list__card.is-active');
  const nextCard = blockId
    ? this.querySelector(`.collage-list__card[data-block-id="${blockId}"]`)
    : null;

  headers.forEach((el) => {
    el.classList.toggle('is-active', !!blockId && el.dataset.blockId === blockId);
  });

  descriptions.forEach((el) => {
    el.classList.toggle('is-active', !!blockId && el.dataset.blockId === blockId);
  });

  if (nextCard && nextCard !== currentCard) {
    nextCard.classList.add('is-active');

    requestAnimationFrame(() => {
      cards.forEach((card) => {
        if (card !== nextCard) {
          card.classList.remove('is-active');
        }
      });
    });
  } else {
    cards.forEach((card) => {
      card.classList.toggle('is-active', !!blockId && card.dataset.blockId === blockId);
    });
  }

  if (this.isAccordion) {
    this.headers.forEach((header) => {
      const panel = this.getPanelForHeader(header);
      if (!panel) return;

      if (blockId && header.dataset.blockId === blockId) {
        header.classList.add('is-active');
        this.setPanelOpen(panel);
      } else {
        header.classList.remove('is-active');
        this.setPanelClosed(panel);
      }
    });
  }
}

      initAccordionPanels() {
        this.headers.forEach((header) => {
          const panel = this.getPanelForHeader(header);
          if (!panel) return;

          panel.style.overflow = 'hidden';
         panel.style.transition = 'max-height 420ms ease-out, opacity 320ms ease';
          panel.style.willChange = 'max-height, opacity';

          if (!header.classList.contains('is-active')) {
            panel.style.maxHeight = '0px';
            panel.style.opacity = '0';
          } else {
            panel.style.opacity = '1';
            panel.style.maxHeight = panel.scrollHeight + 'px';
          }
        });
      }

      refreshOpenPanels() {
        this.headers.forEach((header) => {
          if (!header.classList.contains('is-active')) return;

          const panel = this.getPanelForHeader(header);
          if (!panel) return;

          panel.style.maxHeight = panel.scrollHeight + 'px';
        });
      }

      getPanelForHeader(header) {
        const next = header.nextElementSibling;
        if (next && next.classList.contains('dn-collage-description')) return next;
        return null;
      }

      setPanelOpen(panel) {
        panel.style.opacity = '1';
        requestAnimationFrame(() => {
          panel.style.maxHeight = panel.scrollHeight + 'px';
        });
      }

      setPanelClosed(panel) {
        panel.style.maxHeight = '0px';
        panel.style.opacity = '0';
      }

      toggleHotspot(dot) {
        const hotspot = dot.closest('.lookbook-hotspot');
        const pop = hotspot?.querySelector('.lookbook-pop');
        if (!hotspot || !pop) return;

        const isOpen = hotspot.classList.contains('is-open');
        this.closeAllHotspots();

        if (!isOpen) {
          hotspot.classList.add('is-open');
          dot.setAttribute('aria-expanded', 'true');
        } else {
          hotspot.classList.remove('is-open');
          dot.setAttribute('aria-expanded', 'false');
        }
      }

      closeAllHotspots() {
        this.querySelectorAll('.lookbook-hotspot.is-open').forEach((hotspot) => {
          hotspot.classList.remove('is-open');
          const dot = hotspot.querySelector('[data-lookbook-dot]');
          if (dot) dot.setAttribute('aria-expanded', 'false');
        });
      }

      pauseAllMedia() {
        this.querySelectorAll('video-section[data-type="youtube"] iframe').forEach((video) => {
          video.contentWindow?.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
        });

        this.querySelectorAll('video-section[data-type="vimeo"] iframe').forEach((video) => {
          video.contentWindow?.postMessage('{"method":"pause"}', '*');
        });

        this.querySelectorAll('video').forEach((video) => video.pause());
      }
    }

    customElements.define('dn-collage-list', DnCollageList);
  }
})();